import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconRulesStyle0 = cosmosIconCss;

const CosmosIconRules$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRules extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4e45ac275314b9b46f6d4f2452592f5e0a90f570', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9cbf173f28f3433d70cbf019a0190ff8d30e31da', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3a7c6afbcee4ff8dd3905c832b3d8a9cd7d59efd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.2 8.88v-.02.02Zm0-.016c-.007-.65-.425-.988-1.06-1.414l-1-.58c-.44-.27-.53-.4-.53-.56 0-.16.21-.31.51-.31h1.55A.3.3 0 0 0 7 5.66V5.3a.3.3 0 0 0-.33-.3H5.11c-1 0-1.65.54-1.65 1.3a1 1 0 0 0 .1.45 1.25 1.25 0 0 0-.76 1.14c0 .66.41 1 1.06 1.42l1 .59c.45.27.54.39.54.55 0 .16-.22.34-.52.34H3.33a.3.3 0 0 0-.31.29v.37a.3.3 0 0 0 .31.3h1.56c1 0 1.64-.54 1.64-1.31a1 1 0 0 0-.09-.44c.451-.2.747-.643.76-1.136Zm-1.14.016a.51.51 0 0 1-.22.41l-.27-.18-1.1-.65c-.48-.29-.54-.41-.54-.59a.56.56 0 0 1 .22-.42l.27.18 1.1.66c.48.28.54.41.54.59Zm3.44 1.37a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-9ZM9 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 9 6v-.5Zm.5 10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5h-9Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconRulesStyle0; }
}, [1, "cosmos-icon-rules", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-rules"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-rules":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRules$1);
            }
            break;
    } });
}

const CosmosIconRules = CosmosIconRules$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRules, defineCustomElement };
